export default "__VITE_ASSET__BizNKMTN__"